export default __webpack_public_path__ + "static/media/ysd-004-setu_02.87e98f82.jpg";